import { queryOptions, useQuery } from "@tanstack/react-query"
import { getUser } from "../services/auth"

export const useUser = () => {
    return useQuery(userQueryOptions())
}

export const userQueryOptions = () =>
    queryOptions({
        queryKey: ['user'],
        queryFn: async () => {
            const data = await getUser()
            return data.data.data
        },
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 0
    })
